/**
 * Neurochirurgie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: NEUR
 * Catalogue acts (NGAP Maroc): 567
 */
import { defineSpecialty } from "../types";

export const neurochirurgie = defineSpecialty(
{
  "id": "neurochirurgie",
  "label": "Neurochirurgie",
  "short": "Neurochirurgie",
  "scope": "Crâne, rachis, nerfs périphériques",
  "aliases": [
    "NEUR"
  ],
  "doctorSpecs": [
    "Neurochirurgie"
  ],
  "featureFlag": "ux.v2.neurochirurgie",
  "theme": {
    "primary": "oklch(0.62 0.17 285)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "route": "/clinical/imaging",
      "order": 2,
      "requires": [
        "imaging"
      ]
    },
    {
      "id": "neuro",
      "label": "Neuro",
      "icon": "Brain",
      "route": "/clinical/neuro",
      "order": 3,
      "requires": []
    },
    {
      "id": "surgery",
      "label": "Bloc",
      "icon": "Syringe",
      "route": "/clinical/surgery",
      "order": 4,
      "requires": []
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "component": "ClinicalImageGallery",
      "order": 1,
      "requires": []
    },
    {
      "id": "neuro",
      "label": "Neuro",
      "icon": "Brain",
      "component": "NeuroExamPanel",
      "order": 2,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 3,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Neurochirurgie",
    "subSpecialties": [
      "Consultation",
      "Crâniotomie",
      "Lombotomie",
      "Exploration"
    ],
    "catalogueActs": 567
  },
  "terminology": {
    "icd10": [
      "C00",
      "C70",
      "G40",
      "G90",
      "I60"
    ],
    "loinc": [
      "24937-6",
      "63133-4"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "ct-head",
    "mri-head",
    "eeg-16ch"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default neurochirurgie;
